<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 4H6a2 2 0 00-2 2v36a2 2 0 002 2h36a2 2 0 002-2V6a2 2 0 00-2-2zm-1 3v5H7V7zM7 41V15h34v26z"/><path d="M35 21H13a2 2 0 00-2 2v12a2 2 0 002 2h22a2 2 0 002-2V23a2 2 0 00-2-2zm0 14H13V23h22zM36 17H12a1 1 0 000 2h24a1 1 0 000-2zM22 10.5h4a1 1 0 000-2h-4a1 1 0 000 2z"/><circle cx="11" cy="9.5" r="1"/><circle cx="17" cy="9.5" r="1"/><circle cx="31" cy="9.5" r="1"/><circle cx="37" cy="9.5" r="1"/></svg>